
import {idCardNoUtil} from "../util/validate";
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import XImg from 'vux/src/components/x-img/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Previewer from 'vux/src/components/previewer/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'

import ZhengXin from "./agreement/ZhengXin";
import VerificationCode from "./agreement/verificationCode";
import merge from 'webpack-merge';
import needInput from '../components/needInput.vue';

export default {
directives: {TransferDom},
components: {
PopupPicker,
VerificationCode,
ZhengXin,
Selector,
XButton,
Group,
XDialog,
XImg,
needInput,
Previewer,
Checker,
CheckerItem
},
name: 'FinancingApplication',
data() {
return {
productCode: '',
buninessType: '',
openId: window.sessionStorage.getItem('openId'),
projectId: '',
productId: '',

addressDialog: false,
popupList: {
province: [],
city: [],
area: []
},
popupAddress: {
province: [],
city: [],
area: [],
provinceName: '',
cityName: '',
areaName: ''
},
callbackAddress: {
name: '',
num: ''
},
cityDisabled: true,
areaDisabled: true,

formDisabled: false,
imgDisabled: false,

projectDTO: {},
projectDTOFlag: true,

personDTO: {},
personDTOFlag: true,
occupationFlag: true,
personSpouse: true,

listLinkMan: [],

glist: [],

listCommonDTO: [],

listFileDTO: [],

credentialsType: [],

loanPeriodList: [],
dateList: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31'],

loanPurposeList: [],

maritalStatusList: [],
marriedCode: '',
remarriageCode: '',

relationList: [],
oneselfCode: '',
spouseCode: '',

marriageCertificates: [],
marriageCertificate: {
code: '050',
attachmentName: '',
fileContent: ''
},
householdCertificates: [],
householdCertificate: {
code: '051',
attachmentName: '',
fileContent: ''
},
otherCertificates: [],
agreeChecked: false,
showToast: false,

agreementName: '',
agreementNum: 1,
agreementBtnText: '',
agreementInfo: [
{id: 1, name: "征信查询授权书"},
{id: 2, name: "个人信息查询使用授权书"},
{id: 3, name: "电子认证服务协议（深圳）"},
{id: 4, name: "电子认证服务协议（广州）"},
{id: 5, name: "人脸识别授权书"}
],
taskType: '0',

currentPersonName: '',
currentUser: {},

currentUserMarrige: '',

currentUserIde: '',

spouseIde: false,
requestNumber: 0,//该页面初始化请求后台数据次数

currentkey: '',

fileLength: 0,
productMaxAge: 0, //产品申请人最大年龄限制
weixinStatus: 0, //微信是否自动带出状态
emailStatus: 0,//邮箱是否自动带出状态

mortgageList: [],

selectList: [],
projectDTOCost: true,
provinceBanks: [],
cityBanks: [],
banks: [],
costTypes: [
{
name: '对私',
type: '0',
},
{
name: '对公',
type: '1',
}
],
costCertificates: [],
homeCertificates: [],
ideCertificates: [],
organId: '',//星速贷机构id
showSz: false,
showGz: false,
showSzDealText: '',
showGzDealText: ''
}
},
watch: {
requestNumber: function (val) {

if (val == 5 && !this.projectId) {
this.$vux.loading.hide();
} else if (val == 6 && this.projectId) {
this.$vux.loading.hide();
} else {
this.$vux.loading.show({text: '加载中...'});
}
},
listCommonDTO: {
handler() {

this.addSelectList();
},
deep: true
}
},
created() {
this.currentkey = this.$route.query.currentkey;
this.buninessType = this.$route.query.buninessType;
this.productCode = this.$route.query.productCode
this.projectId = this.$route.query.projectId
this.organId = this.$route.query.organId || ''
this.lendingMainStatus()

if (this.currentkey == 'task') {

window.sessionStorage.setItem("currentkey", "1")
} else if ((this.buninessType != '' || this.buninessType != null || this.buninessType != undefined) && (this.projectId == undefined || this.projectId == '')) {

window.sessionStorage.setItem("currentkey", "2")
} else {

window.sessionStorage.setItem("currentkey", "3")
}

if (this.projectId) {
this.getDelStatus();
}
this.getAddress('35', (callback) => {
this.popupList.province = this.initPopupList(callback)
})
this.getEnumList('loanPurposeType', 'loanPurposeList')
this.getEnumList('Personal_Certificate', 'credentialsType')
this.getEnumList('guaranteePerRel', 'relationList')
this.getSelectList(2, 'maritalStatusList')
this.initForm()

if (this.productCode == '3') {
this.getProvinceList();
this.geBanksList();
}

this.checkEspStatus();


},
computed: {
isOrganization() {

return +this.$route.query.productCode == '3' && this.organId
},

handleFileName(filename) {
return function (filename) {
if (filename == '' || filename == null) {
return '';
}
let filenames = filename.split('.');
if (filenames[0].length > 15) {
return filenames[0].substring(0, 15) + '···';
} else {
return filenames[0];
}
}
},
checkObligee() {
return function (value, list) {
console.log(list)
if (list && list.length <= 0) {
return false;
}

if (list.indexOf(value) == -1) {
return false;
}
return true;
}
}
},
methods: {

checkHouseMeasureArea(item, index) {
if (!item.houseMeasureArea) {
return
}
let value = item.houseMeasureArea
let reg = /^[0-9]+\.?[0-9]*$/g
if (!reg.test(value)) {
this.$vux.confirm.show({
content: '抵押物' + (index + 1) + '的建筑面积格式有误，请重新输入',
showCancelButton: false,
confirmText: '关闭',
hideOnBlur: true
});
this.$set(item, 'houseMeasureArea', '')
} else {
let val = String(Number(Number(value).toFixed(4)))
this.$set(item, 'houseMeasureArea', val)
}
},

lendingMainStatus() {
console.log('是否显示电子协议')
this.$axios({
method: 'post',
url: '/wechat/getLendingMainBodyConfiguration.do'
}).then((response) => {

const lendingMainBody = response.data.result.lendingMainBody;
if (lendingMainBody.length > 0) {
lendingMainBody.forEach(item => {
if (item == "001") {
this.showSz = true
this.showSzDealText = '深圳市银顺通小额贷款有限公司'
}

if (item == "102") {
this.showGz = true
this.showGzDealText = '广州市达顺通小额贷款有限公司'
}


})

} else {
this.showSz = false
this.showGz = false
}

})
},

getDelStatus() {
const thiss = this;
this.$axios({
method: 'post',
url: '/wechat/queryTaskDelete.do ',
data: {
projectId: this.projectId,
openId: window.sessionStorage.getItem('openId')
}
}).then((response) => {

thiss.requestNumber++;
const result = response.data.result;
if (result == '1' || result == '2') {
let txt = '';
if (result == '1') {
txt = '该申请已被删除'
} else {
txt = '该申请已被退回'
}
thiss.$vux.confirm.show({
content: txt, showCancelButton: false, confirmText: '关闭', hideOnBlur: false,
onConfirm() {
const key1 = window.sessionStorage.getItem('currentkey');
if (key1 == '3') {
WeixinJSBridge.call('closeWindow');
window.close();
} else {
thiss.$router.back(-1);
}
}
})
}
}).catch(function (err) {

thiss.requestNumber++;
})
},

checkReturn() {
if (this.currentkey == 'task') {
this.$router.back(-1);
} else {
WeixinJSBridge.call('closeWindow');
}
},
showImage(type, index) {
if (this.projectDTO.status == '0' || this.projectDTO.status == '2') {
return;
}
if (type == 'other') {
this.$refs.previewerOther.show(index)
} else if (type == 'house') {
this.$refs.previewerHouse.show(index)
} else if (type == 'home') {
this.$refs.previewerHome.show(index)
} else if (type == 'cost') {
this.$refs.previewerCost.show(index)
} else if (type == 'ide') {
this.$refs.previewerIde.show(index)
} else {
this.$refs.previewerMarrige.show(index)
}

},
getImage(id) {
return require(`@/assets/images/${id}.png`);
},
agreeDialogShow(name, agreeNum) {
this.agreementBtnText = '关闭'
this.agreementName = name;
this.agreementNum = agreeNum;
this.showToast = true;
this.$nextTick(() => {
this.$refs.agreement.scrollTop = 0;
});
},
agreementFun() {
if (this.agreementBtnText == "关闭") {
this.showToast = false;
this.agreementNum = 1;
return;
}

if (this.agreementNum == 5) {

this.showToast = false;
this.agreementNum = 1;
this.agreeChecked = true;

} else {

this.$nextTick(() => {
this.$refs.agreement.scrollTop = 0;
});
if (this.showSz && !this.showGz && this.agreementNum == 3) {
this.agreementNum = 5
} else if (this.showGz && !this.showSz && this.agreementNum == 2) {
this.agreementNum = 4
} else if (this.showGz && !this.showSz && this.agreementNum == 4) {
this.agreementNum = 5
} else {
this.agreementNum++
}
;
this.agreementName = this.agreementInfo[this.agreementNum - 1].name
if (this.agreementNum == 5) {
this.agreementBtnText = "同意";
} else {
this.agreementBtnText = "查看下一份";
}
}
},
checkChange() {
if (this.formDisabled && this.imgDisabled) {
return false
}
if (this.agreeChecked) {
this.agreeChecked = !this.agreeChecked;
} else {
this.agreeDialogShow("征信查询授权书", 1);
this.agreementBtnText = "查看下一份";
}
},

relationChange(num, relation) {
if (relation !== this.oneselfCode) {
if (this.listLinkMan[num].name === this.personDTO.name) this.listLinkMan[num].name = ''
if (this.listLinkMan[num].handset === this.personDTO.handset) this.listLinkMan[num].handset = ''
} else if (relation !== this.spouseCode) {
if (this.listLinkMan[num].name === this.personDTO.partnerName) this.listLinkMan[num].name = ''
if (this.listLinkMan[num].handset === this.personDTO.partnerHandset) this.listLinkMan[num].handset = ''
}
},

changeItemFlag(index, listName) {
const $this = this
$this[listName][index].showFlag = !$this[listName][index].showFlag
},

moneyFormat(data1, data2, value) {
const $this = this
if (typeof (value) != "undefined" && '' != value && null != value) {
value = value.toString().replace(/\$|\,/g, '');
if (isNaN(value)) {
value = "0";
$this[data1][data2] = value
}
value = Math.abs(value)
value = Math.floor(value * 100 + 0.50000000001);
let cents = value % 100;
value = Math.floor(value / 100).toString();
if (cents < 10)
cents = "0" + cents;



$this[data1][data2] = value + '.' + cents
} else {
$this[data1][data2] = "0.00"
}
if (this.productCode == '1') {
if (typeof (value) != "undefined" && '' != value && null != value) {
$this[data1][data2] = this.filterMoney1(value, 2);
} else {
$this[data1][data2] = '0';
}
}
},

filterMoney1: function (money, len = 2, split = ',') {
len = Math.abs((+len) % 20);
money = parseFloat((money + "").replace(/[^\d.-]/g, "")).toFixed(len) + "";
return money.replace(/\d+/, function (money) {
let lit = money.length % 3 == 0;
let index = lit ? money.length - 3 : -1;
return money.split('').reverse().join('').replace(/\d{3}/g, function (k, l) {
return k + ((l == index && lit) ? "" : split);
}).split('').reverse().join('')
});
},

contactNumCheck(type, title, value, refName, array, index, column, parentIndex) {
const $this = this
if (!value || value === '') {


if (title != '单位电话' && type != 'weixin' && type != 'email') {

$this.$vux.confirm.show({
content: title + '不能为空',
showCancelButton: false,
confirmText: '关闭',
hideOnBlur: true
})
}

return false
}

let re = /^[a-zA-Z0-9]([-_a-zA-Z0-9]{5,19})+$/;
let email = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/;
if (type === 'weixin') {
if (!re.test(value)) {
$this.$vux.confirm.show({
content: title + '格式有误，请重新输入',
showCancelButton: false,
confirmText: '关闭',
hideOnBlur: true
});
if (Array.isArray($this[array])) {
$this[array][index].weixinNo = '';
} else {
$this[array].weixinNo = '';
}
}
return;
}
if (type === 'email') {
if (!email.test(value)) {
$this.$vux.confirm.show({
content: title + '格式有误，请重新输入',
showCancelButton: false,
confirmText: '关闭',
hideOnBlur: true
});
if (Array.isArray($this[array])) {
$this[array][index].email = '';
} else {
$this[array].email = '';
}
}
return;
}

const phoneReg = /^\d{11}$/
const numReg = /^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/;
if (type === 'phone') {
if (!phoneReg.test(value)) {

$this.$vux.confirm.show({
content: title + '格式有误，请重新输入',
showCancelButton: false,
confirmText: '关闭',
hideOnBlur: true
})
if (Array.isArray($this[array])) {
$this[array][index][column] = '';
} else if (array === 'obligeeList') {
$this.mortgageList[parentIndex]['obligeeList'][index].obligeePhone = '';
} else {
$this[array][index] = '';
}
return false
}
} else {
if (!phoneReg.test(value) && !numReg.test(value)) {


$this.$vux.confirm.show({
content: title + '格式有误，请重新输入',
showCancelButton: false,
confirmText: '关闭',
hideOnBlur: true
})
if (Array.isArray($this[array])) {
$this[array][index][column] = '';
} else {
$this[array][index] = '';
}
return false
}
}

},

nameCheck(value, parentlist, tip, formDisabled) {

if (formDisabled) {
return
}
if (value && value.includes(' ')) {
this.$vux.confirm.show({
content: tip + '不能包含空格',
showCancelButton: false,
confirmText: '关闭',
hideOnBlur: true
})
let parent = this
parentlist.forEach((item, index) => {
if (index < parentlist.length - 1) {
parent = parent[item]
}
})
this.$set(parent, parentlist[parentlist.length - 1], '')
}
},

idNumCheck(title, value, isBlackCheck, array, index, refName, parentIndex) {

this.spouseIde = false;
const $this = this
if (!value || value === '') {

$this.$vux.confirm.show({
content: title + '不能为空',
showCancelButton: false,
confirmText: '关闭',
hideOnBlur: true
})

return false
}
if (!idCardNoUtil.checkIdCardNo(value)) {
$this.$vux.confirm.show({
content: title + '长度不对，或者号码不符合规定！15位号码应全为数字，18位号码末位可以为数字或大写X。',
showCancelButton: false,
confirmText: '关闭',
hideOnBlur: true
})
if (refName == 'common' || refName == 'g') {


$this.$set($this[array][index], 'phoneStatus', 0);

}

if (Array.isArray($this[array])) {
$this[array][index].ide = '';
} else if (array === 'obligeeList') {
$this.mortgageList[parentIndex]['obligeeList'][index].obligeeNum = '';
} else {
$this[array][index] = '';
}

return false
}

if (isBlackCheck) {
const url = '/wechat/isCanJoinApply.do?ide=' + value
$this.$axios({
method: 'get',
url: url
}).then((response) => {
if (response.data.code === 200) {
const result = response.data.result.isCanJoin;
const r = response.data.result;

if (refName === 'g' && response.data.result.movePhone) {
$this.glist[index].phone = response.data.result.movePhone;

$this.$set($this[array][index], 'phoneStatus', 1);














}

if (refName === 'g' && !response.data.result.movePhone) {
$this.$vux.confirm.show({
content: '该担保人未注册',
showCancelButton: false,
confirmText: '关闭',
hideOnBlur: true
})
$this.glist[index].ide = '';
$this.glist[index].phone = '';
}
if (refName === 'common' && !response.data.result.movePhone) {
$this.$vux.confirm.show({
content: '该共借人人未注册',
showCancelButton: false,
confirmText: '关闭',
hideOnBlur: true
})
$this.listCommonDTO[index].ide = '';
$this.listCommonDTO[index].handset = '';
}

if (refName === 'common' && response.data.result.movePhone) {
$this[array][index].handset = r.movePhone;
$this.$set($this[array][index], 'phoneStatus', 1);














}


if (refName === 'common' && !response.data.result.movePhone) {
$this.$set($this[array][index], 'phoneStatus', 0);
}

if (result === '1') {

$this.$vux.confirm.show({
content: title + '黑名单用户不允许申请',
showCancelButton: false,
confirmText: '关闭',
hideOnBlur: true
})
$this[array][index] = ''
} else if (result === '2') {

$this.$vux.confirm.show({
content: title + '拒单客户3个月内不能申请',
showCancelButton: false,
confirmText: '关闭',
hideOnBlur: true
})
$this[array][index] = ''
}
} else {

$this.$vux.confirm.show({
content: response.data.message,
showCancelButton: false,
confirmText: '关闭',
hideOnBlur: true
})
}
})
}
},

otherIdNumCheck(title, value, type) {
const $this = this
if (!value || value === '') {

$this.$vux.confirm.show({
content: title + '不能为空',
showCancelButton: false,
confirmText: '关闭',
hideOnBlur: true
})

this.spouseIde = true;
return false
}
if (type === '1010105') {
const r = /^(P\d{7})|(G\d{8})$/
if (!r.test(value)) {

$this.$vux.confirm.show({
content: title + '长度不对，或者号码不符合规定！',
showCancelButton: false,
confirmText: '关闭',
hideOnBlur: true
})
this.spouseIde = true;
this.personDTO.partnerIDE = '';
return;
}
} else if (type === 'ENU160615000014') {
const r = /^[HM]\d{8,10}$|^\d{8}$/
if (!r.test(value)) {

$this.$vux.confirm.show({
content: title + '长度不对，或者号码不符合规定！',
showCancelButton: false,
confirmText: '关闭',
hideOnBlur: true
})
this.spouseIde = true;
this.personDTO.partnerIDE = '';
return;
}
} else if (type === 'ENU160810000015') {
const r = /^[A-Z]\d{6}\([\dA]\)$/
if (!r.test(value)) {

$this.$vux.confirm.show({
content: title + '长度不对，或者号码不符合规定！',
showCancelButton: false,
confirmText: '关闭',
hideOnBlur: true
})
this.spouseIde = true;
this.personDTO.partnerIDE = '';
return;
}
}

this.spouseIde = false;
},

changeIDTypeCheck(type, val) {
if (type === '1010101') {
if (val === null) {
return;
}
this.idNumCheck('配偶的证件号', val, false, 'personDTO', 'partnerIDE')
} else {
if (val === null) {
return;
}
this.otherIdNumCheck('配偶的证件号', val, type)
}
},


getEnumList(euumType, arrayName) {
const $this = this
const url = '/wechat/queryEuumList.do?euumType=' + euumType
this.$axios({
method: 'get',
url: url
}).then((response) => {
if (response.data.code === 200) {
$this[arrayName] = response.data.result
if (euumType === 'guaranteePerRel') {
for (let i = 0; i < response.data.result.length; i++) {
if (response.data.result[i].name === '本人') {
$this.oneselfCode = response.data.result[i].enumId
} else if (response.data.result[i].name === '配偶') {
$this.spouseCode = response.data.result[i].enumId
}
}
}
$this.requestNumber++;
} else {
$this.requestNumber++;

$this.$vux.confirm.show({
content: response.data.message,
showCancelButton: false,
confirmText: '关闭',
hideOnBlur: true
})
}
})
},


getSelectList(num, arrayName) {
const $this = this
const url = '/wechat/querydropDownBoxList.do?num=' + num
this.$axios({
method: 'get',
url: url
}).then((response) => {
if (response.data.code === 200) {
$this[arrayName] = response.data.result
if (num === 2) {
for (let i = 0; i < response.data.result.length; i++) {
if (response.data.result[i].name === '已婚') {
$this.marriedCode = response.data.result[i].ENUMID
} else if (response.data.result[i].name === '再婚') {
$this.remarriageCode = response.data.result[i].ENUMID
}
}
}
$this.requestNumber++;
} else {
$this.requestNumber++;

$this.$vux.confirm.show({
content: response.data.message,
showCancelButton: false,
confirmText: '关闭',
hideOnBlur: true
})
}
})
},

getProvinceList() {
const $this = this
const url = '/wechat/queryBankProvinceList.do'
this.$axios({
method: 'get',
url: url
}).then((response) => {
if (response.data.code === 200) {
$this.provinceBanks = response.data.result;
$this.provinceBanks.forEach(item => {
item.name = item.bankAreaProvince;
});

} else {


$this.$vux.confirm.show({
content: response.data.message,
showCancelButton: false,
confirmText: '关闭',
hideOnBlur: true
})
}
})
},

getCityList() {
const $this = this
const url = '/wechat/queryBankAreaCity.do'
this.$axios({
method: 'get',
url: url,
params: {
bankAreaProvince: this.projectDTO.loanBankProvince
},
}).then((response) => {
if (response.data.code === 200) {
$this.cityBanks = response.data.result;
$this.cityBanks.forEach(item => {
item.name = item.bankAreaCity;
});
} else {

$this.$vux.confirm.show({
content: response.data.message,
showCancelButton: false,
confirmText: '关闭',
hideOnBlur: true
})
}
})
},
changeProvinceBank() {
if (this.projectDTO.loanBankProvince)
this.getCityList();
},

geBanksList() {
const $this = this
const url = '/wechat/queryEuumList.do?euumType=AccountOpenBank'
this.$axios({
method: 'get',
url: url,
}).then((response) => {
if (response.data.code === 200) {
$this.banks = response.data.result;

} else {


$this.$vux.confirm.show({
content: response.data.message,
showCancelButton: false,
confirmText: '关闭',
hideOnBlur: true
})
}
})
},

personMarriageChange() {
if (this.personDTO.marriage === this.marriedCode || this.personDTO.marriage === this.remarriageCode) {
this.personSpouse = true
}

this.currentUserMarrige = this.personDTO.marriage;

},
checkWeixinEmail(person) {

if (person.weixinNo) {
this.weixinStatus = 1;
}
if (person.email) {
this.emailStatus = 1;
}
;
},

checkWeixinEmailg(list) {
if (list.length <= 0) {
return;
}

list.forEach((item, index) => {






if (item.handset) {
item.phoneStatus = 1;
}
});
},


checkWeixinEmaild(list) {
if (list.length <= 0) {
return;
}

list.forEach((item, index) => {






if (item.phone) {
item.phoneStatus = 1;
}
});
},


initForm() {
const $this = this
const url = '/wechat/fincApply.do'
const buninessType = $this.$route.query.buninessType;
const projectId = $this.$route.query.projectId
this.$axios({
method: 'post',
url: url,
data: {
openId: $this.openId,
buninessType: buninessType,
projectId: projectId
}
}).then((response) => {
if (response.data.code === 200) {
const result = response.data.result;



$this.projectDTO = result.projectDTO
if ($this.projectDTO.channelType) {

this.organId = $this.projectDTO.channelType
}
$this.loanPeriodList = result.applyGuaTermList
if (result.projectDTO.buninessType && result.projectDTO.buninessType !== '') {
$this.productId = result.projectDTO.buninessType
} else {
$this.productId = buninessType
$this.projectDTO.buninessType = buninessType
}
$this.personDTO = $this.changePersonInfo('init', result.personDTO)
if (result.listLinkMan && result.listLinkMan.length > 0) {
$this.listLinkMan = $this.changeCommonInfo('init', result.listLinkMan)
} else {
$this.addItem('contact', 'listLinkMan')
}

$this.glist = result.glist && result.glist.length > 0 ? $this.changeGuaranteeInfo('init', result.glist) : []
if ($this.productCode == '0' && $this.glist.length === 0) {
$this.addItem('guarantee', 'glist')
}
$this.listCommonDTO = result.listCommonDTO && result.listCommonDTO.length > 0 ? $this.changeCommonInfo('init', result.listCommonDTO) : []
$this.listFileDTO = result.listFileDTO && result.listFileDTO.length > 0 ? $this.changeCertificateInfo('init', result.listFileDTO) : []
$this.mortgageList = result.mortgageList && result.mortgageList.length > 0 ? $this.changeCommonInfo('init', result.mortgageList) : [];

$this.mortgageList = $this.changeMortInfo($this.mortgageList);

$this.pageStatus($this.projectDTO.status);

$this.requestNumber++;
$this.queryCurrentUser($this.projectDTO.personType, $this.personDTO.name, $this.personDTO.ide);



} else {

$this.$vux.confirm.show({
content: response.data.message,
showCancelButton: false,
confirmText: '关闭',
hideOnBlur: true
})
}
}).catch((err) => {
$this.requestNumber++;
$this.$vux.toast.text(err)
})
},


pageStatus(status) {
if (status === '1' || status === '3' || status === '5') {
this.formDisabled = true
this.imgDisabled = true
this.agreeChecked = true
} else if (status === '2') {
this.formDisabled = true
this.imgDisabled = false
} else if (status === '4') {
this.formDisabled = true
this.imgDisabled = true
this.agreeChecked = true
} else {
this.formDisabled = false
this.imgDisabled = false
if (this.productCode == '3') {
this.projectDTO.applyGuaTerm = '5';
}
}
},

checkMortPerson() {
let result = false;
this.mortgageList.some((item, index) => {
if (item.checkList.length <= 0) {
this.$vux.confirm.show({
content: `抵押物${index + 1}请选择权利人`,
showCancelButton: false,
confirmText: '关闭',
hideOnBlur: true
})
result = true;
return true;
}
});
return result;
},

checkPhoto() {
if (this.productCode == '1') {

if (this.ideCertificates.length <= 0) {

this.$vux.confirm.show({
content: "请提交身份证明资料！",
showCancelButton: false,
confirmText: '关闭',
hideOnBlur: true
})
return true;
}
if (this.homeCertificates.length <= 0) {

this.$vux.confirm.show({
content: "请提交房产证明资料！",
showCancelButton: false,
confirmText: '关闭',
hideOnBlur: true
})
return true;
}
return false;

}

if (this.marriageCertificates.length > 10) {

this.$vux.confirm.show({
content: "婚姻证明资料提交数量不能超过10！",
showCancelButton: false,
confirmText: '关闭',
hideOnBlur: true
})
return true;
}
if (this.householdCertificates.length > 10) {

this.$vux.confirm.show({
content: "户口证明资料提交数量不能超过10！",
showCancelButton: false,
confirmText: '关闭',
hideOnBlur: true
})
return true;
}
if (this.otherCertificates.length > 10) {

this.$vux.confirm.show({
content: "其他资料提交数量不能超过10！",
showCancelButton: false,
confirmText: '关闭',
hideOnBlur: true
})
return true;
}
if (this.productCode == '3') {
if (this.costCertificates.length > 10) {

this.$vux.confirm.show({
content: "还款流水证明资料提交数量不能超过10！",
showCancelButton: false,
confirmText: '关闭',
hideOnBlur: true
})
return true;
}
if (this.homeCertificates.length > 10) {

this.$vux.confirm.show({
content: "房产证明提交数量不能超过10！",
showCancelButton: false,
confirmText: '关闭',
hideOnBlur: true
})
return true;
}
if (this.homeCertificates.length <= 0 && this.projectDTO.status != '2') {

this.$vux.confirm.show({
content: "请提交房产证明资料！",
showCancelButton: false,
confirmText: '关闭',
hideOnBlur: true
})
return true;
}
}
if (this.householdCertificates.length <= 0 && this.productCode != '3') {

this.$vux.confirm.show({content: "请提交户口证明资料！", showCancelButton: false, confirmText: '关闭', hideOnBlur: true})
return true;
}


if (this.currentUserMarrige != '331' && this.productCode == '0') {
if (this.marriageCertificates.length <= 0) {

this.$vux.confirm.show({content: "请提交婚姻证明！", showCancelButton: false, confirmText: '关闭', hideOnBlur: true})
return true;
}
}

return false;

},

reduceImage(file, code, filename, list) {
const thiss = this;
lrz(file).then(function (rst) {
let item = {
code: code,
attachmentName: filename,
fileContent: rst.base64,
src: rst.base64
}
list.push(item);
thiss.fileLength--;
if (thiss.fileLength <= 0) {
thiss.$vux.loading.hide();
}

}).catch(function (error) {

thiss.$vux.confirm.show({
content: "图片错误，请重新上传图片！",
showCancelButton: false,
confirmText: '关闭',
hideOnBlur: true
})
thiss.$vux.loading.hide();
}).always(function () {

})























},

listPhoto(fileList, objectList, code) {
const thiss = this;
let errorTip = '';
for (let i = 0; i < fileList.length; i++) {
const size = Math.ceil(fileList[i].size / 1024 / 1024);
let fileUrl = ''
const name = fileList[i].name
if (size > 10) {
errorTip = '请选择10M以内的图片！'
} else {
this.convertImgToBase64(fileList[i], (base64) => {

thiss.reduceImage(base64, code, name, objectList);







})
}
}
if (errorTip !== '') {

this.$vux.confirm.show({content: errorTip, showCancelButton: false, confirmText: '关闭', hideOnBlur: true})
this.$vux.loading.hide();
}
},

takePhoto(event) {
this.$vux.loading.show({text: '上传中...'})
var ua = navigator.userAgent;
var wechatInfo = ua.match(/MicroMessenger\/([\d\.]+)/i);
var filter = [{
title: "Image files",
extensions: "jpg,png,jpeg"
}];

if (/android/.test(ua.toLowerCase()) && wechatInfo && parseFloat(wechatInfo[1]) > 6.3) {
filter = [];
}
const $this = this

const inputName = event.target.name
const fileList = event.target.files;
this.fileLength = fileList.length;
if (inputName == 'arrayFile') {
this.listPhoto(fileList, this.otherCertificates, '080');
}
if (inputName == 'marrigeFile') {
this.listPhoto(fileList, this.marriageCertificates, '050');
}
if (inputName == 'houseFile') {
this.listPhoto(fileList, this.householdCertificates, '051');
}
if (inputName == 'costFile') {
this.listPhoto(fileList, this.costCertificates, '052');
}
if (inputName == 'homeFile') {
this.listPhoto(fileList, this.homeCertificates, '025');
}
if (inputName == 'ideFile') {
this.listPhoto(fileList, this.ideCertificates, '002');
}
event.target.value = '';

},

convertImgToBase64(imageFile, callback, errorCallback) {
const thiss = this;
try {
let reader = new FileReader()
reader.readAsDataURL(imageFile)
reader.onload = function (e) {
if (callback) {
let base64Str = e.target.result
callback(base64Str)
}
}
} catch (error) {
this.$vux.loading.hide();
console.error(error)
if (errorCallback) {
errorCallback(error)
}
}
},

deleteSingle(name) {
this.$refs[name].value = '';
if (name === 'marriageFile') {
this.marriageCertificate.fileContent = ''
} else if (name === 'householdFile') {
this.householdCertificate.fileContent = ''
}
},

arrayDelete(index, name) {
if (name == 'arrayFile') {
this.otherCertificates.splice(index, 1)
}
if (name == 'marrigeFile') {
this.marriageCertificates.splice(index, 1);
}
if (name == 'houseFile') {
this.householdCertificates.splice(index, 1);
}
if (name == 'costFile') {
this.costCertificates.splice(index, 1);
}
if (name == 'homeFile') {
this.homeCertificates.splice(index, 1);
}
if (name == 'ideFile') {
this.ideCertificates.splice(index, 1);
}
},

addItem(type, array) {
const $this = this
let item = {}
if (type === 'contact') {
item = {
name: '',
relationNotice: '',
handset: '',
showFlag: true
}
} else if (type === 'guarantee') {
item = {
userName: '',
ide: '',
phone: '',
province: '',
city: '',
area: '',
address: '',
marriage: '',
showFlag: true
}
} else if (type === 'mort') {
item = {
houseName: '',
houseNumber: '',
houseAddress: '',
houseMeasureArea: '',
houseArea: '',
houseCity: '',
houseProvince: '',
obligeeList: [],
showFlag: true,
checkList: [],
areaName: '',
cityName: '',
provinceName: ''
}
} else {
item = {
name: '',
ideType: '1010101',
ide: '',
handset: '',
houseProvince: '',
houseCity: '',
housearea: '',
houseaddress: '',
marriage: '',
showFlag: true
}
}
$this[array].push(item)
},

deleteItem(index, array) {
const $this = this
$this[array].splice(index, 1)
},
requiredCheck() {

var inputList = document.querySelectorAll("input[required]");
var checkFalse = false;
for (let i = 0; i < inputList.length; i++) {
let inpObj = inputList[i];
inpObj.setCustomValidity(''); 
if (inpObj.checkValidity() == false) {
if (inpObj.value == "") {
let txt = inpObj.getAttribute("placeholder") || "请把信息填完整!";

this.$vux.confirm.show({content: txt, showCancelButton: false, confirmText: '关闭', hideOnBlur: true})
checkFalse = true;
let top = inpObj.offsetTop;
while (inpObj = inpObj.offsetParent) {
top += inpObj.offsetTop;
}
window.scrollTo({top: top - 100, behavior: "smooth"})
break;
}
}
if (inpObj.placeholder === '请选择与申请人关系' && inpObj.value === this.spouseCode) {
if (!(this.personDTO.partnerName && this.personDTO.partnerHandset && this.personDTO.partnerName !== '' && this.personDTO.partnerHandset !== '')) {

this.$vux.confirm.show({
content: '其他联系人有配偶关系，请完善申请人配偶信息！',
showCancelButton: false,
confirmText: '关闭',
hideOnBlur: true
})
checkFalse = true;
let top = inpObj.offsetTop;
while (inpObj = inpObj.offsetParent) {
top += inpObj.offsetTop;
}
window.scrollTo({top: top - 100, behavior: "smooth"})
break;
}
}
}
if (checkFalse) {
return true;
}
return false;
},
beforeSubmitForm(state) {
if (this.requiredCheck()) {
return;
}
let that = this


var isOk = true;
if (this.productCode == '0') {
if (this.listLinkMan != null && Array.isArray(this.listLinkMan)) {
for (let i = 0; i < this.listLinkMan.length; i++) {
if (this.glist != null && Array.isArray(this.glist)) {
for (let j = 0; j < this.glist.length; j++) {
if ((this.listLinkMan[i].handset == this.glist[j].phone) && (this.listLinkMan[i].name == this.glist[j].userName)) {
this.$vux.confirm.show({
content: '联系人中存在和担保人名称和手机号一致！',
showCancelButton: false,
confirmText: '关闭',
hideOnBlur: true
})
return;
} else if (this.listLinkMan[i].handset == this.glist[j].phone) {
this.$vux.confirm.show({
content: '联系人中存在和担保人手机号一致！',
showCancelButton: false,
confirmText: '关闭',
hideOnBlur: true
})
return;
} else if (this.listLinkMan[i].name == this.glist[j].userName) {
isOk = false
this.$vux.confirm.show({
content: '联系人中存在和担保人名称一致！', hideOnBlur: true,
onCancel() {
return;
},
onConfirm() {
that.submitForm(state)
return;
}
})
}
if ((this.glist[j].phone == this.personDTO.handset) && (this.glist[j].userName == this.personDTO.name)) {
this.$vux.confirm.show({
content: '担保人中存在和借款人名称和手机号一致！',
showCancelButton: false,
confirmText: '关闭',
hideOnBlur: true
})
return true;
} else if (this.glist[j].phone == this.personDTO.handset) {
this.$vux.confirm.show({
content: '担保人中存在和借款人手机号一致！',
showCancelButton: false,
confirmText: '关闭',
hideOnBlur: true
})
return true;
} else if (this.glist[j].userName == this.personDTO.name) {
isOk = false
this.$vux.confirm.show({
content: '担保人中存在和借款人名称一致！', hideOnBlur: true,
onCancel() {
return;
},
onConfirm() {
that.submitForm(state)
return;
}
})
}
}
}

if ((this.listLinkMan[i].handset == this.personDTO.handset) && (this.listLinkMan[i].name == this.personDTO.name)) {
this.$vux.confirm.show({
content: '联系人中存在和借款人名称和手机号一致！',
showCancelButton: false,
confirmText: '关闭',
hideOnBlur: true
})
return true;
} else if (this.listLinkMan[i].handset == this.personDTO.handset) {
this.$vux.confirm.show({
content: '联系人中存在和借款人手机号一致！',
showCancelButton: false,
confirmText: '关闭',
hideOnBlur: true
})
return true;
} else if (this.listLinkMan[i].name == this.personDTO.name) {
isOk = false
this.$vux.confirm.show({
content: '联系人中存在和借款人名称一致！', hideOnBlur: true,
onCancel() {
return;
},
onConfirm() {
that.submitForm(state)
return;
}
})
}
}
}
}
if (isOk) {
that.submitForm(state)
}
},


submitForm(state) {
if (this.productCode != '3' || !this.isOrganization) {

if (this.checkPhoto()) {
return;
}


if (this.productCode == '3' && this.checkMortPerson()) {
return;
}

if (this.spouseIde && (this.currentUserMarrige == '330' || this.currentUserMarrige == '1700173')) {

this.$vux.confirm.show({
content: '配偶证件号错误,请重新填写！',
showCancelButton: false,
confirmText: '关闭',
hideOnBlur: true
})
return;
}
}

const $this = this
if (state === '1' && !$this.agreeChecked) {








$this.$vux.confirm.show({
content: '请先勾选同意授权并阅读《征信查询授权书》、《个人信息查询使用授权书》、《电子认证服务协议》、《人脸识别授权书》',
showCancelButton: false,
confirmText: '关闭',
hideOnBlur: true
})
return false
}
const url = '/wechat/saveProject.do'
let dataParams = {}
if (this.organId) {
$this.projectDTO.channelType = this.organId
$this.projectDTO.isInput = "2"
}
dataParams.saveType = state
dataParams.projectDTO = JSON.parse(JSON.stringify($this.projectDTO));
dataParams.personDTO = JSON.parse(JSON.stringify($this.personDTO))
dataParams.listLinkMan = JSON.parse(JSON.stringify($this.listLinkMan))
dataParams.glist = JSON.parse(JSON.stringify($this.glist))
dataParams.listCommonDTO = JSON.parse(JSON.stringify($this.listCommonDTO))
dataParams.listFileDTO = JSON.parse(JSON.stringify($this.listFileDTO))
dataParams.mortgageList = JSON.parse(JSON.stringify($this.mortgageList))

dataParams.listLinkMan = $this.changeContactsInfo('submit', dataParams.listLinkMan)
dataParams.glist = $this.changeGuaranteeInfo('submit', dataParams.glist)
dataParams.listCommonDTO = $this.changeCommonInfo('submit', dataParams.listCommonDTO)
dataParams.listFileDTO = $this.changeCertificateInfo('submit', dataParams.listFileDTO)
dataParams.mortgageList = $this.changeMortSumbitInfo('submit', dataParams.mortgageList)
if (this.productCode == '3') {
dataParams.glist = [];
dataParams.listLinkMan = [];
if (this.isOrganization) {

let projectDTONeed = ['projectId', 'isFirstLoan', 'personId', 'projectCode', 'applyGuaSum', 'applyGuaTerm', 'applyDate', 'regDate', 'buninessType', 'buninessTypeName', 'status', 'personType', 'channelType', 'isInput', 'houseCity', 'houseCityName', 'houseProvince', 'houseProvinceName', 'houseaddress', 'houseaddressName', 'housearea', 'houseareaName']
Object.keys(dataParams.projectDTO).forEach(key => {
if (!projectDTONeed.includes(key)) {
delete dataParams.projectDTO[key]
}
})
let personDTONeed = ['personId', 'openId', 'name', 'ideType', 'ide', 'handset', 'code', 'createddate', 'verifyCode', 'status', 'email', 'weixinNo', 'houseCity', 'houseCityName', 'houseProvince', 'houseProvinceName', 'houseaddress', 'houseaddressName', 'housearea', 'houseareaName']
Object.keys(dataParams.personDTO).forEach(key => {
if (!personDTONeed.includes(key)) {
delete dataParams.personDTO[key]
}
})
dataParams = {
saveType: dataParams.saveType,
projectDTO: dataParams.projectDTO,
personDTO: dataParams.personDTO,
listCommonDTO: dataParams.listCommonDTO
}
}
}
if (this.productCode == '1') {
dataParams.personDTO.salarymonth = dataParams.personDTO.salarymonth.replace(/,/g, '');
dataParams.projectDTO.applyGuaSum = dataParams.projectDTO.applyGuaSum.replace(/,/g, '');
dataParams.projectDTO.isFirstLoan = '新增客户';
}

$this.$axios({
method: 'post',
url: url,
data: dataParams
}).then((response) => {
if (response.data.code === 200) {
const result = response.data.result
$this.projectDTO.projectId = result.projectId
$this.projectId = result.projectId
if (state === '1') {
$this.projectDTO.status = '3';
$this.pageStatus($this.projectDTO.status);
$this.$router.push({
query: merge({}, {
projectId: $this.projectId,
productCode: $this.productCode
})
})

$this.goFaceAfterSubmit()
} else {

$this.$vux.confirm.show({
content: '保存成功，可在个人中心-待办中查询该暂存任务',
showCancelButton: false,
confirmText: '关闭',
hideOnBlur: true
})
$this.$router.go(-1)
}
} else {
if (response.data.message) {

$this.$vux.confirm.show({
content: response.data.message,
showCancelButton: false,
confirmText: '关闭',
hideOnBlur: true
})
} else {
$this.$vux.toast.text('后台错误，请联系后台人员！')
}
}
}).catch((err) => {
$this.$vux.toast.show({text: err, time: 5000})
})
},

submitFile() {
const $this = this
if (this.checkPhoto()) {
return;
}
if (!$this.agreeChecked) {








$this.$vux.confirm.show({
content: '请先勾选同意授权并阅读《征信查询授权书》、《个人信息查询使用授权书》、《电子认证服务协议》、《人脸识别授权书》',
showCancelButton: false,
confirmText: '关闭',
hideOnBlur: true
})
return false
}
const url = '/wechat/saveProjectFile.do'
const dataParams = {}

dataParams.projectId = $this.projectDTO.projectId;
dataParams.openId = $this.openId;
dataParams.productCode = $this.productCode;
dataParams.listFileDTO = $this.changeCertificateInfo('submit', dataParams.listFileDTO)

$this.$axios({
method: 'post',
url: url,
data: dataParams
}).then((response) => {
if (response.data.code === 200) {

$this.goFaceAfterSubmit()
$this.projectDTO.status = '3';
$this.pageStatus($this.projectDTO.status);
} else {
if (response.data.message) {

$this.$vux.confirm.show({
content: response.data.message,
showCancelButton: false,
confirmText: '关闭',
hideOnBlur: true
})
} else {
$this.$vux.toast.text('后台错误，请联系后台人员！')
}
}
}).catch((err) => {
$this.$vux.toast.text(err)
})
},

changePersonInfo(state, object) {
if (state === 'init') {
object.openId = this.openId
if (object.salarymonth && object.salarymonth !== '') {
this.moneyFormat('personDTO', 'salarymonth', object.salarymonth)
object.salarymonth = this.personDTO.salarymonth
}
if (this.projectDTO.applyGuaSum && this.projectDTO.applyGuaSum !== '') {
this.moneyFormat('projectDTO', 'applyGuaSum', this.projectDTO.applyGuaSum)
}
}
return object
},
changeMortInfo(list) {
list.forEach(item => {
item.checkList = [];
if (item.obligeeList) {
item.obligeeList.forEach(item1 => {
item.checkList.push(item1.obligeeNum);
})
}
});
this.addSelectList();

return list;
},
addSelectList() {
this.selectList = [];
this.selectList.push({
ide: this.personDTO.ide,
name: this.personDTO.name,
type: '主借人',
phone: this.personDTO.handset
});
this.listCommonDTO.forEach(item => {
if (item.name && item.ide && item.handset)
this.selectList.push({ide: item.ide, name: item.name, type: '共借人', phone: item.handset});
});

this.mortgageList.forEach((item, index) => {
this.changeMortNumber(index);
});
},
changeMortNumber(index) {
this.mortgageList[index].obligeeList = [];
if (this.mortgageList[index].checkList.length > 0) {
this.mortgageList[index].checkList.forEach(item => {
this.selectList.forEach(item1 => {
if (item === item1.ide) {
const obb = {
obligeeName: item1.name,
obligeeNum: item1.ide,
obligeePhone: item1.phone
}
this.mortgageList[index].obligeeList.push(obb)
}
})
});
}
console.log(this.mortgageList)
},

changeContactsInfo(state, list) {
if (state === 'init') {
for (let i = 0; i < list.length; i++) {
list[i].showFlag = false
}
list[0].showFlag = true
} else {
for (let i = 0; i < list.length; i++) {
if (list[i].relationNotice === this.oneselfCode) {
list[i].name = this.personDTO.name
list[i].handset = this.personDTO.handset
} else if (list[i].relationNotice === this.spouseCode) {
list[i].name = this.personDTO.partnerName
list[i].handset = this.personDTO.partnerHandset
}
delete list[i].showFlag
}
}
return list
},

changeGuaranteeInfo(state, list) {
if (state === 'init') {
for (let i = 0; i < list.length; i++) {
list[i].showFlag = false
}
if (this.productCode === '0') {
list[0].showFlag = true
}
} else {
for (let i = 0; i < list.length; i++) {
delete list[i].showFlag;
delete list[i].phoneStatus;

delete list[i].weixinStatus;

delete list[i].emailStatus;
}
}
return list
},

changeCommonInfo(state, list) {
if (state === 'init') {
for (let i = 0; i < list.length; i++) {
list[i].showFlag = false
}
list[0].showFlag = true
} else {
for (let i = 0; i < list.length; i++) {
delete list[i].showFlag;
delete list[i].phoneStatus;

delete list[i].weixinStatus;

delete list[i].emailStatus;
}
}
return list
},

changeMortSumbitInfo(state, list) {
if (state === 'init') {
for (let i = 0; i < list.length; i++) {
list[i].showFlag = false
}
list[0].showFlag = true
} else {
for (let i = 0; i < list.length; i++) {
delete list[i].showFlag;
delete list[i].checkList;
}
}
return list
},

changeCertificateInfo(state, list) {
if (state === 'init') {
for (let i = 0; i < list.length; i++) {
if (list[i].code === '050') {
const marrige = {
...list[i],
code: list[i].code,
attachmentName: list[i].attachmentName,
fileContent: list[i].fileContent,
src: list[i].fileContent
}
this.marriageCertificates.push(marrige);
} else if (list[i].code === '051') {
const house = {
...list[i],
code: list[i].code,
attachmentName: list[i].attachmentName,
fileContent: list[i].fileContent,
src: list[i].fileContent
}
this.householdCertificates.push(house);
} else if (list[i].code === '052') {
const cost = {
...list[i],
code: list[i].code,
attachmentName: list[i].attachmentName,
fileContent: list[i].fileContent,
src: list[i].fileContent
}
this.costCertificates.push(cost);
} else if (list[i].code === '025') {
const home = {
...list[i],
code: list[i].code,
attachmentName: list[i].attachmentName,
fileContent: list[i].fileContent,
src: list[i].fileContent
}
this.homeCertificates.push(home);
} else if (list[i].code === '002') {
const ide = {
...list[i],
code: list[i].code,
attachmentName: list[i].attachmentName,
fileContent: list[i].fileContent,
src: list[i].fileContent
}
this.ideCertificates.push(ide)
} else {
const item = {
...list[i],
code: list[i].code,
attachmentName: list[i].attachmentName,
fileContent: list[i].fileContent,
src: list[i].fileContent
}
this.otherCertificates.push(item)
}
}
} else {
list = []
this.marriageCertificates.forEach(function (item, index) {
let marriage = {
code: item.code,
attachmentName: item.attachmentName,
fileContent: item.fileContent,
}
list.push(marriage);
});
this.householdCertificates.forEach(function (item, index) {
let house = {
code: item.code,
attachmentName: item.attachmentName,
fileContent: item.fileContent,
}
list.push(house);
});
this.otherCertificates.forEach(function (item, index) {
let other = {
code: item.code,
attachmentName: item.attachmentName,
fileContent: item.fileContent,
}
list.push(other);
});
this.costCertificates.forEach(function (item, index) {
let cost = {
code: item.code,
attachmentName: item.attachmentName,
fileContent: item.fileContent,
}
list.push(cost);
});
this.homeCertificates.forEach(function (item, index) {
let home = {
code: item.code,
attachmentName: item.attachmentName,
fileContent: item.fileContent,
}
list.push(home);
});
this.ideCertificates.forEach(function (item, index) {
let home = {
code: item.code,
attachmentName: item.attachmentName,
fileContent: item.fileContent,
}
list.push(home);
});

}
return list
},



faceRecognition() {
const openId = window.sessionStorage.getItem('openId');
const url = "/wechat/livenessValid.do";
this.$axios({
method: "post",
url: url,
data: {
projectId: this.projectId,
openId: openId,
}
}).then(response => {
if (response.data.code === 200) {
const {erCode, erMsg, verifycode, bucket, key, token, operate, url: uploadUrl} = response.data.result;

if (erCode == 0) {
if (operate == 1 || operate == 0) {
this.$router.push({
name: 'faceRecognition',
query: {
projectId: this.projectId,
productId: this.productId,
productCode: this.productCode,
taskType: 0
}
});
} else if (operate == 2 || operate == 3) {

window.sessionStorage.setItem("pagePositioning", "pagePositioning");
if (operate == 2) {
localStorage.setItem('uploadUrl', uploadUrl);
}

this.$router.push({
name: 'livefaceRecognition',
query: {
projectId: this.projectId,
productId: this.productId,
productCode: this.productCode,
taskType: '0',
verifycode,
bucket,
key,
token,
operate
}
});
} else {
this.$vux.toast.text(erMsg);
}
} else {
this.$vux.toast.text(erMsg);
}
} else {

}
});

},

goFaceAfterSubmit() {
const $this = this
const openId = window.sessionStorage.getItem('openId');
const url = '/wechat/validCode.do';
$this.$axios({
method: 'post',
url: url,
data: {
verifyCode: '',
projectId: $this.projectId,
openId: openId,
taskType: $this.taskType
}
}).then((response) => {
if (response.data.code === 200) {
const {erCode, verifycode, bucket, key, token, operate, url: uploadUrl} = response.data.result;

if (erCode == 0 || erCode == '000000' || erCode == '0000000') {
if (operate == 1 || operate == 0) {
$this.$router.push({
name: 'faceRecognition',
query: {
projectId: $this.projectId,
productId: $this.productId,
productCode: $this.productCode,
taskType: $this.taskType
}
});
} else if (operate == 2 || operate == 3) {

window.sessionStorage.setItem("pagePositioning", "pagePositioning");
if (operate == 2) {
localStorage.setItem('uploadUrl', uploadUrl);
}
$this.$router.push({
name: 'livefaceRecognition',
query: {
projectId: $this.projectId,
productId: $this.productId,
productCode: $this.productCode,
taskType: $this.taskType,
verifycode,
bucket,
key,
token,
operate
}
});
} else {
$this.$vux.toast.text(response.data.result.erMsg);
}
} else {
$this.$vux.toast.text(response.data.result.erMsg);
}
} else {

$this.$vux.confirm.show({
content: '认证跳转失败，请重试',
showCancelButton: false,
confirmText: '重试',
hideOnBlur: true,
onConfirm() {
$this.goFaceAfterSubmit()
}
})
}
}).catch(() => {
$this.$vux.confirm.show({
content: '认证跳转失败，请重试',
showCancelButton: false,
confirmText: '重试',
hideOnBlur: true,
onConfirm() {
$this.goFaceAfterSubmit()
}
})
});
},

getAddress(pId, callback) {
const $this = this
const url = '/wechat/queryAreaList.do?pId=' + pId
$this.$axios({
method: 'get',
url: url
}).then((response) => {
if (response.data.code === 200) {
callback(response.data.result)
}
})
},

initPopupList(list) {
let newList = []
for (let i = 0; i < list.length; i++) {
let item = {
name: list[i].name,
value: list[i].id
}
newList.push(item)
}
return [newList]
},

provinceChange(val) {
this.popupList.city.length = 0
this.popupAddress.city[0] = []
this.popupList.area.length = 0
this.popupAddress.area[0] = []
this.cityDisabled = true
this.areaDisabled = true
this.popupAddress.cityName = ''
for (let i = 0; i < this.popupList.province[0].length; i++) {
if (this.popupList.province[0][i].value === val[0]) {
this.popupAddress.provinceName = this.popupList.province[0][i].name
break;
}
}
this.getAddress(val, (callback) => {
this.popupList.city = this.initPopupList(callback)
this.cityDisabled = false
})
},

cityChange(val) {
this.popupList.area.length = 0
this.popupList.area[0] = []
this.areaDisabled = true
this.popupAddress.areaName = ''
for (let i = 0; i < this.popupList.city[0].length; i++) {
if (this.popupList.city[0][i].value === val[0]) {
this.popupAddress.cityName = this.popupList.city[0][i].name
break;
}
}
this.getAddress(val, (callback) => {
this.popupList.area = this.initPopupList(callback)
this.areaDisabled = false
})
},

areaChange(val) {
for (let i = 0; i < this.popupList.area[0].length; i++) {
if (this.popupList.area[0][i].value === val[0]) {
this.popupAddress.areaName = this.popupList.area[0][i].name
break;
}
}
},

addressSelect(province, city, area, name, provinceName, cityName, areaName, num) {
if (this.formDisabled) {
return false
}
if (province && province !== '') {
this.getAddress(province, (callback) => {
this.popupList.city = this.initPopupList(callback)
this.cityDisabled = false
})
} else {
this.popupList.city.length = 0
this.cityDisabled = true
}
if (city && city !== '') {
this.getAddress(city, (callback) => {
this.popupList.area = this.initPopupList(callback)
this.areaDisabled = false
})
} else {
this.popupList.area.length = 0
this.areaDisabled = true
}
this.popupAddress.province[0] = province && province !== '' ? province : ''
this.popupAddress.city[0] = city && city !== '' ? city : ''
this.popupAddress.area[0] = area && area !== '' ? area : ''
this.popupAddress.provinceName = provinceName && provinceName !== '' ? provinceName : ''
this.popupAddress.cityName = cityName && cityName !== '' ? cityName : ''
this.popupAddress.areaName = areaName && areaName !== '' ? areaName : ''
this.callbackAddress.name = name
this.callbackAddress.num = num
this.addressDialog = true
},

sureAddress() {
const $this = this
if ($this.popupAddress.provinceName === '' || $this.popupAddress.cityName === '' || $this.popupAddress.areaName === '') {

$this.$vux.confirm.show({content: '请完善省市县信息！', showCancelButton: false, confirmText: '关闭', hideOnBlur: true})
return false
}
if (this.callbackAddress.name === 'personDTO') {
$this.personDTO = {
...$this.personDTO,
houseProvince: $this.popupAddress.province[0],
houseCity: $this.popupAddress.city[0],
housearea: $this.popupAddress.area[0],
houseProvinceName: $this.popupAddress.provinceName,
houseCityName: $this.popupAddress.cityName,
houseareaName: $this.popupAddress.areaName
}
} else if (this.callbackAddress.name === 'glist') {
const index = $this.callbackAddress.num
$this.glist[index] = {
...$this.glist[index],
province: $this.popupAddress.province[0],
city: $this.popupAddress.city[0],
area: $this.popupAddress.area[0],
provinceName: $this.popupAddress.provinceName,
cityName: $this.popupAddress.cityName,
areaName: $this.popupAddress.areaName
}
} else if (this.callbackAddress.name === 'mortgageList') {
const index = $this.callbackAddress.num;

$this.mortgageList[index].houseProvince = $this.popupAddress.province[0];
$this.mortgageList[index].houseCity = $this.popupAddress.city[0];
$this.mortgageList[index].houseArea = $this.popupAddress.area[0];
$this.mortgageList[index].provinceName = $this.popupAddress.provinceName;
$this.mortgageList[index].cityName = $this.popupAddress.cityName;
$this.mortgageList[index].areaName = $this.popupAddress.areaName;
} else {
const index = $this.callbackAddress.num
$this.listCommonDTO[index] = {
...$this.listCommonDTO[index],
houseProvince: $this.popupAddress.province[0],
houseCity: $this.popupAddress.city[0],
housearea: $this.popupAddress.area[0],
houseProvinceName: $this.popupAddress.provinceName,
houseCityName: $this.popupAddress.cityName,
houseareaName: $this.popupAddress.areaName
}
}
$this.addressDialog = false
},

checkEspStatus() {
const thiss = this;
const openid = window.sessionStorage.getItem("openId");
if (!openid) {
return;
}
const url = '/wechat/queryUser.do?openId=' + openid;
this.$axios({
method: 'get',
url: url
}).then((response) => {
if (response.data.code === 200) {

if (response.data.result.espstatus == null || String(response.data.result.espstatus) === '0') {
thiss.$router.push({path: '/register'});
} else if (String(response.data.result.espstatus) === '1' || String(response.data.result.espstatus) === '3') {
thiss.$router.push({path: '/personInfo'});
}
} else {
thiss.$router.push({path: '/register'});
}
}).catch(() => {});
},

queryCurrentUser(type, userName, ide) {

if (type === "1") {

this.currentPersonName = userName;
this.currentUserIde = ide;
return;
}
const thiss = this;
const openid = window.sessionStorage.getItem("openId");
const url = '/wechat/queryUser.do?openId=' + openid;
this.$axios({
method: 'get',
url: url
}).then((response) => {
if (response.data.code === 200) {
thiss.currentPersonName = response.data.result.userName;
thiss.currentUser = response.data.result;
thiss.currentUserIde = response.data.result.ide;

thiss.queryMerriage(type);

} else {

}
});
},

queryMerriage(type) {
const thiss = this;

if (type == '3') {
this.glist.forEach(function (item) {
if (item.ide == thiss.currentUser.ide) {
thiss.currentUserMarrige = item.marriage;
return;
}
});
} else {
this.listCommonDTO.forEach(function (item) {
if (item.ide == thiss.currentUser.ide) {
thiss.currentUserMarrige = item.marriage;
return;
}
});
}


},
getPlaceholder(title, value) {
if (this.formDisabled) {
if (!this.value) {
return '';
}
} else {
return title;
}
}
}
}



// WEBPACK FOOTER //
// ./src/pages/FinancingApplication.vue